'use client';
import type { ComponentType, PropsWithChildren } from 'react';
import { memo } from 'react';
import { Remount } from '../../../../../components/Remount';
import { compose } from '../../../../../utils/compose';
import { BaseGlobalAppStateStoreProvider } from '../BaseGlobalAppStateStoreProvider';
import type { BaseGlobalAppStateStoreProviderProps, WithRemountProps } from '../types';
import { useResolvedRunnerDeviceDetails } from './hooks/useResolvedRunnerDeviceDetails';

function withRunnerDeviceDetails(
  Component: ComponentType<PropsWithChildren<BaseGlobalAppStateStoreProviderProps>>,
) {
  function Wrapper(props: PropsWithChildren<BaseGlobalAppStateStoreProviderProps>) {
    const { deviceDetails, key } = useResolvedRunnerDeviceDetails(props.deviceDetails);

    return <Component {...props} deviceDetails={deviceDetails} key={key} />;
  }

  return Wrapper;
}

const withRemount = (
  Component: ComponentType<PropsWithChildren<BaseGlobalAppStateStoreProviderProps>>,
) => {
  function Wrapper(props: PropsWithChildren<BaseGlobalAppStateStoreProviderProps>) {
    return <Remount>{(remount) => <Component {...props} remount={remount} />}</Remount>;
  }

  return Wrapper;
};

export const RunnerGlobalAppStateStoreProvider = compose<
  ComponentType<PropsWithChildren<WithRemountProps>>
>(
  memo,
  withRemount,
  withRunnerDeviceDetails,
)(BaseGlobalAppStateStoreProvider);
